import React from 'react';
import { PropTypes } from 'prop-types';

const COLORS = {
  warning: 'orange',
  info: 'blue-dark',
  success: 'green',
  error: 'red',
};

const Tag = ({ variant, text }) => (
  <div className={`bg-${COLORS[variant]} rounded-sm flex absolute right-0 mr-5 capitalize`}>
    <span className="px-2 py-1 text-white text-xs font-bold">{text}</span>
  </div>
);

Tag.propTypes = {
  variant: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Tag;
